import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-security-officer',
  templateUrl: './security-officer.component.html',
  styleUrls: ['./security-officer.component.scss']
})
export class SecurityOfficerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
